/*
 * shopit-api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.41
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {CartItems} from './CartItems';
import {User} from './User';

/**
 * The Checkout model module.
 * @module model/Checkout
 * @version v1
 */
export class Checkout {
  /**
   * Constructs a new <code>Checkout</code>.
   * @alias module:model/Checkout
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>Checkout</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/Checkout} obj Optional instance to populate.
   * @return {module:model/Checkout} The populated <code>Checkout</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new Checkout();
      if (data.hasOwnProperty('supplier_id'))
        obj.supplier_id = ApiClient.convertToType(data['supplier_id'], 'String');
      if (data.hasOwnProperty('user'))
        obj.user = User.constructFromObject(data['user']);
      if (data.hasOwnProperty('items'))
        obj.items = CartItems.constructFromObject(data['items']);
      if (data.hasOwnProperty('collection_date'))
        obj.collection_date = ApiClient.convertToType(data['collection_date'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} supplier_id
 */
Checkout.prototype.supplier_id = undefined;

/**
 * @member {module:model/User} user
 */
Checkout.prototype.user = undefined;

/**
 * @member {module:model/CartItems} items
 */
Checkout.prototype.items = undefined;

/**
 * @member {String} collection_date
 */
Checkout.prototype.collection_date = undefined;

